import styles from './styles.module.scss';

function MandatoryBadge({ show, selectedForm }) {
  const badgeText = selectedForm === 'person' ? 'اختیاری' : 'اجباری';

  return show && <span className={styles.mandatory_badge}>{badgeText}</span>;
}

export default MandatoryBadge;
